export const CONDITION_LABEL = {
    s: '状態S',
    a: '状態A',
    b: '状態B',
    c: '状態C',
}
